module.exports = require("./yue-Hant.d.ts");